export const TEMPLATE_CATEGORIES = [
  'Associations',
  'Consulting et coaching',
  'Travaux et rénovations',
  'Marketing',
  'Informatique et applis',
  'Immobilier',
  'Droit et finance',
  'Voitures et transports',
  'Agriculture et jardinage',
  'Animaux et vétérinaires',
  'Santé & bien-être',
  'Sport et fitness',
  "Hôtels et chambres d'hôtes",
  'Appartements et Auberges',
  'Services voyage',
  'Gastronomie et traiteurs',
  'Restaurants',
  'Cafés et boulangeries',
];

export const DEFAULT_TEMPLATE_CATEGORY = 'Marketing';
